export default __webpack_public_path__ + "static/media/magicsnacks@2x.901b79b8.jpg";